import RootState from 'typings/RootState'
import { Event } from 'Store/common/common.types'
import { MasterProducsData, ManufacturList, MerchantSummaryData, OverallDashboardData } from './types'
// export const selectTopsaleDashboard = (state: RootState): TopSaleData | undefined =>
//   state.dashboarcReducer.topSale

export const selectEventDashboard = (state: RootState): Event => state.miniRmxReducer.event

export const selectActionEvent = (state: RootState): Event => state.miniRmxReducer.actionEvent

export const selectMasterProduct = (state: RootState): MasterProducsData[] =>
  state.miniRmxReducer.masterProducsData

export const selectManufacturDashboard = (state: RootState): ManufacturList =>
  state.miniRmxReducer.manufacturList

export const selectManufacturListevent = (state: RootState): Event => state.miniRmxReducer.manufacturListevent

export const selectMerchantSummaryDashboard = (state: RootState): MerchantSummaryData | undefined =>
  state.miniRmxReducer.merchantSummaryData

export const selectMerchantSummaryEvent = (state: RootState): Event =>
  state.miniRmxReducer.merchantSummaryEvent

export const selectOverallDashboard = (state: RootState): OverallDashboardData | undefined =>
  state.miniRmxReducer.overallDashboardData

export const selectOverallDashboardEvent = (state: RootState): Event =>
  state.miniRmxReducer.overallDashboardEvent
